<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: REVENUE -->
      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          v-if="!loading"
          icon="DollarSignIcon"
          statisticTitle="Revenue Generated"
          :statistic="revenueGenerated.analyticsData.total"
          :chartData="revenueGenerated.series"
          type="area"
        ></statistics-card-line>
      </div>
      <!-- CARD 2: TICKET -->
      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          v-if="!loading"
          icon="UsersIcon"
          statisticTitle="Tickets"
          :statistic="tickets.analyticsData.total"
          :chartData="tickets.series"
          type="area"
        ></statistics-card-line>
      </div>
      <!-- CARD 3: ORDERS -->
      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          v-if="!loading"
          icon="CheckCircleIcon"
          statisticTitle="Confirmed Orders"
          :statistic="confirmedOrder.analyticsData.total"
          :chartData="confirmedOrder.series"
          type="area"
        ></statistics-card-line>
      </div>
    </div>

    <div class="vx-row">
      <!-- COMPARE CHART -->
      <div class="vx-col w-full md:w-2/3 mb-base">
        <vx-card title="Revenue">
          <template slot="actions">
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="cursor-pointer"
            >
              {{ comparedOptions.filter(x => x.selected == true)[0].title }}
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  @click="onComparedOptionChanged(item)"
                  v-for="(item, index) in comparedOptions"
                  :key="index"
                  >{{ item.title }}</vs-dropdown-item
                >
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <div class="flex" v-if="revenueComparisonLine.analyticsData">
              <div class="mr-6">
                <p class="mb-1 font-semibold">
                  {{
                    comparedOptions.filter(x => x.selected == true)[0].main_text
                  }}
                </p>
                <p class="text-2xl text-success">
                  <!-- <sup class="text-base mr-1">$</sup> -->
                  {{
                    revenueComparisonLine.analyticsData.main.toLocaleString()
                  }}
                </p>
              </div>
              <div>
                <p class="mb-1 font-semibold">
                  {{
                    comparedOptions.filter(x => x.selected == true)[0]
                      .compare_text
                  }}
                </p>
                <p class="text-2xl">
                  <!-- <sup class="text-base mr-1">$</sup> -->
                  {{
                    revenueComparisonLine.analyticsData.compare.toLocaleString()
                  }}
                </p>
              </div>
            </div>
            <vue-apex-charts
              v-if="!loading"
              type="line"
              height="266"
              :options="analyticsData.revenueComparisonLine.chartOptions"
              :series="revenueComparisonLine.series"
            />
          </div>
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Lead-to-Conversion">
          <template slot="actions">
            <feather-icon
              icon="HelpCircleIcon"
              svgClasses="w-6 h-6 text-grey"
            ></feather-icon>
          </template>

          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10">
              <vue-apex-charts
                type="radialBar"
                height="257"
                :options="analyticsData.goalOverviewRadialBar.chartOptions"
                :series="goalOverview.series"
              />
            </div>
          </template>

          <!-- DATA -->
          <div
            class="flex justify-between text-center mt-6"
            slot="no-body-bottom"
          >
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
            >
              <p class="mt-4">Orders</p>
              <p class="mb-4 text-2xl font-semibold">
                {{ goalOverview.orders | numFormat("0,0") }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Paid</p>
              <p class="mb-4 text-2xl font-semibold">
                {{ goalOverview.paid | numFormat("0,0") }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Pending</p>
              <p class="mb-4 text-2xl font-semibold">
                {{ goalOverview.pending | numFormat("0,0") }}
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <!-- RECENT ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Recent Orders">
          <div slot="no-body" class="mt-4 px-3">
            <!--
            <vs-table :data="dispatchedOrders" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>Status</vs-th>
                <vs-th>Pay Code</vs-th>
                <vs-th>Paid On</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Email</vs-th>
                <vs-th>Phone</vs-th>
                <vs-th>Amount</vs-th>
                <vs-th>Quantity</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].orderNo">
                    <span>#{{data[indextr].orderNo}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    <span class="flex items-center px-2 py-1 rounded">
                      <div
                        class="h-3 w-3 rounded-full mr-2"
                        :class="'bg-' + data[indextr].statusColor"
                      ></div>
                      {{data[indextr].status}}
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <ul class="users-liked user-list">
                      <li v-for="(user, userIndex) in data[indextr].usersLiked" :key="userIndex">
                        <vx-tooltip :text="user.name" position="bottom">
                          <vs-avatar
                            :src="user.img"
                            size="23px"
                            class="border-2 border-white border-solid -m-1"
                          ></vs-avatar>
                        </vx-tooltip>
                      </li>
                    </ul>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].location}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].distance}}</span>
                    <vs-progress
                      :percent="data[indextr].distPercent"
                      :color="data[indextr].statusColor"
                    ></vs-progress>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].startDate}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].estDelDate}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].estDelDate}}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>-->

            <b-table
              ref="table"
              striped
              hover
              fixed
              responsive
              show-empty
              sort-icon-left
              :selectable="true"
              :select-mode="`multi`"
              :busy.sync="isBusy"
              :items="dataProvider"
              :fields="columns"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filterIncludedFields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2" style="height:600px;">
                  <b-spinner class="align-middle"></b-spinner>
                  <div class="mt-3">
                    <strong>Loading...</strong>
                  </div>
                </div>
              </template>
              <template v-slot:cell(rowstatus)="data">
                <div>
                  <vs-chip
                    v-bind:class="data.value.toLowerCase().replace(' ', '')"
                  >
                    {{ data.value.toUpperCase() }}
                  </vs-chip>
                </div>
              </template>
              <template v-slot:cell(unique_id)="data">
                <div style="width:70px;">{{ data.value }}</div>
              </template>
              <template v-slot:cell(name)="data">
                <div style="width:150px;">
                  {{ data.value.first }} {{ data.value.last }}
                </div>
              </template>

              <template v-slot:cell(amount)="data">
                <div>{{ data.value | numFormat("0,0.00") }}</div>
              </template>

              <template v-slot:cell(quantity)="data">
                <div>
                  <vs-button
                    @click="openTicket(data.item)"
                    type="border"
                    class
                    color="grey"
                    >{{ data.value }}</vs-button
                  >
                </div>
              </template>

              <template v-slot:cell(upload)="data">
                <i
                  v-if="data.value != 'n'"
                  class="far fa-file-image fa-2x"
                  @click="showSlip(data)"
                ></i>
                <span v-else>N</span>
              </template>

              <template v-slot:cell(approve)="data">
                <i v-if="data.value == 'y'" class="fas fa-check fa-2x"></i>
                <span v-if="data.value == 'n'">N</span>
              </template>

              <template v-slot:cell(paidby)="data">
                <div @click="onOpenCreditCardDialog(data)">
                  <i
                    v-if="data.value == 'creditcard'"
                    class="far fa-credit-card fa-2x"
                  ></i>
                  <i
                    v-if="data.value == 'transfer'"
                    class="fas fa-exchange-alt fa-2x"
                  ></i>
                </div>
              </template>

              <template v-slot:cell(errors)="data">
                <div v-for="(error, index) in data.value" :key="index">
                  <div v-if="error.res_msg">
                    {{ index + 1 }}. {{ error.res_msg }}
                  </div>
                </div>
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown size="sm" text="Actions" variant="outline-danger">
                  <b-dropdown-item
                    v-for="(item, index) in data.value"
                    :key="index"
                    @click="onAction(data.item, item)"
                  >
                    <i :class="item.icon" class="cursor-pointer"></i>
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <template v-slot:cell(remark)="data">
                <div @click="openEditRemark(data.item)">
                  <vs-input
                    class="inputx"
                    :disabled="true"
                    placeholder="Placeholder"
                    v-model="data.value"
                  />
                </div>
              </template>
            </b-table>
          </div>
          <div class="text-right">
            <router-link to="/orders">
              <vs-button class="mt-0">All Orders</vs-button>
            </router-link>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "@/utils/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";

import { mapState } from "vuex";
import Service from "../services";
export default {
  name: "Home",
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data: () => ({
    loading: true,
    isBusy: false,
    analyticsData: analyticsData,
    revenueGenerated: {
      series: [
        {
          name: "Value",
          data: []
        }
      ],
      analyticsData: {
        total: 0
      }
    },
    tickets: {
      series: [
        {
          name: "Value",
          data: []
        }
      ],
      analyticsData: {
        total: 0
      }
    },
    confirmedOrder: {
      series: [
        {
          name: "Value",
          data: []
        }
      ],
      analyticsData: {
        total: 0
      }
    },
    revenueComparisonLine: {
      analyticsData: {
        main: 0,
        compare: 0
      },
      series: [
        {
          name: "Last Month",
          data: []
        },
        {
          name: "This Month",
          data: []
        }
      ]
    },
    goalOverview: {
      analyticsData: {
        completed: 786617,
        inProgress: 13561
      },
      series: [0],
      orders: 0,
      paid: 0,
      pending: 0
    },
    dispatchedOrders: [],
    comparedOptions: [
      {
        title: "Today (vs Yesterday)",
        value: "today",
        main_text: "Totay",
        compare_text: "Yesterday",
        selected: false
      },
      {
        title: "Yesterday (vs day before)",
        value: "yesterday",
        main_text: "Yesterday",
        compare_text: "Day Before",
        selected: false
      },
      {
        title: "This week (vs Last week)",
        value: "week",
        main_text: "Week",
        compare_text: "Previous Week",
        selected: false
      },
      {
        title: "This month (vs Last month)",
        value: "month",
        main_text: "Month",
        compare_text: "Previous Month",
        selected: true
      }
    ],
    columns: [
      {
        label: "Status",
        key: "rowstatus"
      },
      { label: "Pay Code", key: "unique_id", sortable: true },
      { label: "Paid", key: "paid_date", sortable: true },
      { label: "Name", key: "name", sortable: true, sortable: true },
      { label: "Email", key: "email", sortable: true },
      { label: "Phone", key: "phone", sortable: true },
      { label: "Amount", key: "amount", sortable: true },
      { label: "Quantity", key: "quantity", sortable: true }
    ],
    currentPage: 1,
    perPage: 10,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    event: null,
    currency: ""
  }),
  created() {
    Service.Event.get(this.e).then(event => {
      this.currency = event.data.event.currency;

      setTimeout(() => {
        this.loadDashboard();
        this.loadCompareChart("month");
        this.loadOverview();
      }, 2000);
    });
  },
  methods: {
    loadDashboard() {
      let data = {
        e: this.e,
        start: "2022-05-01 00:00:00",
        end: "2022-05-31 23:59:59"
      };
      Service.Event.dashboard(data).then(res => {
        this.revenueGenerated.series[0].data = res.data.revenue.data.map(
          item => {
            return item.value;
          }
        );
        this.tickets.series[0].data = res.data.tickets.data.map(item => {
          return item.value;
        });
        this.confirmedOrder.series[0].data = res.data.confirmed.data.map(
          item => {
            return item.value;
          }
        );
      });
    },
    loadCompareChart(type) {
      this.loading = true;

      let comparedData = {
        e: this.e,
        type: type
      };

      /* RESET SERIES */
      this.revenueComparisonLine.series[0].data = [];
      this.revenueComparisonLine.series[1].data = [];
      this.analyticsData.revenueComparisonLine.chartOptions.xaxis.categories = [];

      Service.Event.dashboardCompare(comparedData).then(res => {
        let xaxis = [];
        let total = { main: 0, compare: 0 };

        /* main */
        this.revenueComparisonLine.series[0].data = res.data.main.data.map(
          item => {
            total.main += item.value;
            return item.value;
          }
        );

        /* compare */
        this.revenueComparisonLine.series[1].data = res.data.compared.data.map(
          item => {
            xaxis.push(item.title.split("-")[2]);
            total.compare += item.value;
            return item.value;
          }
        );
        this.analyticsData.revenueComparisonLine.chartOptions.xaxis.categories = xaxis;
        this.revenueComparisonLine.analyticsData.main =
          total.main.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          " " +
          (!this.currency || this.currency == 'null' ? "" : this.currency);
        this.revenueComparisonLine.analyticsData.compare =
          total.compare.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          " " +
          (!this.currency || this.currency == 'null' ? "" : this.currency);

        this.loading = false;
      });
    },
    loadOverview() {
      setTimeout(() => {
        // console.log(this.$route.query.e);
        let overViewData = {
          e: this.$route.query.e
        };

        let params = Object.keys(overViewData)
          .map(key => key + "=" + overViewData[key])
          .join("&");

        Service.Report.overview(params).then(res => {
          this.goalOverview.series = [
            parseInt(res.data[res.data.length - 1].PaidRatio.slice(0, -1))
          ];

          this.goalOverview.orders = res.data[res.data.length - 1].Orders;
          this.goalOverview.paid = res.data[res.data.length - 1].Paid;
          this.goalOverview.pending =
            res.data[res.data.length - 1].PaymentPending;

          this.revenueGenerated.analyticsData.total =
            res.data[res.data.length - 1].Revenue.toString().replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            ) +
            " " +
            (this.currency || '');

          this.tickets.analyticsData.total = res.data[
            res.data.length - 1
          ].Tickets.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.confirmedOrder.analyticsData.total = res.data[
            res.data.length - 1
          ].Paid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        });
      }, 500);
    },
    dataProvider(ctx, callback) {
      this.isBusy = true;
      setTimeout(() => {
        //console.log("selectedView " + this.selectedView);
        let data = {
          e: this.$route.query.e,
          view: "needaction",
          page: this.currentPage
        };

        if (this.$route.query.o) {
          data.o = this.$route.query.o;
        }

        data.tp = "";

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.Lagacy.get_orders(params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;

            //this.log = res.log;
            this.lagacy_query = res.lagacy_query;

            //return this.data;
            callback(this.data);
          })
          .catch(error => {
            //console.log(error);
            callback([]);
          });

        return null;
      }, 500);
    },
    onComparedOptionChanged(item) {
      this.comparedOptions.map(item => {
        item.selected = false;
      });

      this.comparedOptions.find(x => x.value == item.value).selected = true;
      this.loadCompareChart(item.value);
    }
  }
};
</script>
